module.exports = {"components":{"al-merge-tags-selector":{"form_labels":{"select_guestlist":"Select guestlist","field_group":"Type of fields","field":"Field","preview_entity":"Select guest for preview","preview":"Preview"},"merge_tag_head":"Merge Tag"}},"modals":{"merge-tag-modal":{"title":"Select your placeholder (Merge Tag)","buttons":{"add_merge_tag":"Add Merge Tag"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/merge-tags.json
// module id = 2398
// module chunks = 1